/*
 * @Author: zhenglfsir@gmail.com
 * @Date: 2018-09-10 09:42:32
 * @Last Modified by: zhenglfsir@gmail.com
 * @Last Modified time: 2019-04-28 10:39:24
 * 标识当前版本，便于确认是否更新
 */
import { isDev } from './env';

export default () => {
  window.__APPLICATION_VERSION__ = process.env.VERSION || 'v0.0.0';
  const consStyle =
    ' color: #fff; font-weight: 500; background-color: #000; padding: 5px 10px; border-radius: 3px;';
  !isDev() && console.log(`当前应用版本: %c${window.__APPLICATION_VERSION__}`, consStyle);
};
export const version = process.env.VERSION || 'v0.0.0';